/*
 * ***********************************************************************
 * Bounteous CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Bounteous.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property
 * of Bounteous and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Bounteous
 * and its suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Bounteous.
 * ***********************************************************************
 */

/**
 * Affinity Teaser.
 */

import { Component, registerComponent } from 'js/component.js';
import Carousel from '../../../../carousel/clientlibs/site/js/carousel.js';

const componentName = 'cmp-experience-fragment--affinity';
export class ExperienceFragment extends Component {

    baseXfPath = this.element.dataset.baseXfPath;
    affinityCategory = this.element.dataset.tagNamespace.split('/')[1];

    /**
     *
     * Checks if an affinity exists for a user.
     */
    isKnownUser() {
        return !!window.localStorage.getItem('affinity');
    }

    /**
     * Gets content for an XF variation.
     */
    async getXFContent(variation) {
        let xfContent;
        const isAuthorEnv = getCookie('cq-authoring-mode');
        const uri = `${variation}.affinity.html`;

        try {
            const response = await fetch(uri + isAuthorEnv ? '?wcmmode=disabled' : '');
            xfContent = await response.text();
        } catch (e) {
            xfContent = this.baseContent;
        }

        return xfContent;
    }

    /**
     * Updates the XF variation to the selected value from the CTA dropdown component.
     */
    async updateXFContent(affinity) {
        const xfPath = this.baseXfPath.replace('master', affinity);
        const xfVariationContent = await this.getXFContent(xfPath);
        this.element.innerHTML = xfVariationContent;
        const carousel = this.element.querySelector('.carousel');

        if (carousel) {
            new Carousel(carousel).init();
        }
    }

    /**
     * Loads the correct XF Variation
     */
    loadXfVariation(value) {
        const valueArray = value.split('/');
        const xfVariationName = valueArray[valueArray.length - 1];
        this.updateXFContent(xfVariationName);
    }

    /**
     * Add event listeners.
     */
    addEventListeners() {
        window.addEventListener('SDI-DLM:affinity', (event) => {
            const { category, value } = event.detail;
            const { tagNamespace } = this.element.dataset;
            if (tagNamespace.indexOf(category) !== -1) {

                this.loadXfVariation(value);
            }
        });
    }

    /**
     * Initialize Component.
     */
    async init() {
        this.baseContent = await this.getXFContent(this.baseXfPath);
        if (this.isKnownUser()) {
            const affinities = JSON.parse(window.localStorage.getItem('affinity'));
            const affinity = affinities[this.affinityCategory];
            if (affinity) {
                this.loadXfVariation(affinity.value);
            }
        }

        this.addEventListeners();
    }
}

function getCookie(name) {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
}

registerComponent(`.${componentName}`, ExperienceFragment);
